import React, { useState } from "react";
import { MdExpandLess, MdExpandMore  } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { IoAlertCircle } from "react-icons/io5";
import { MdDangerous } from "react-icons/md";

const Alerts = ({ data }) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  // Define all alerts in a unified array
  const allAlerts = [
    {
      heading: "Meltable",
      subheading: data?.meltable
        ? "The product is Meltable"
        : "The product is not Meltable",
      tick: !data?.meltable,
      isDanger: false,
      getValue: () => data?.meltable,
    },
    {
      heading: "Amazon Share Buy Box",
      subheading: data?.amazonShareBuyBox
        ? "Amazon is present on this listing"
        : "Amazon does not hold the buy box",
      tick: !data?.amazonShareBuyBox,
      isDanger: false,
      getValue: () => data?.amazonShareBuyBox,
    },
    {
      heading: "Hazmat or Dangerous goods",
      subheading: data?.hazmat
        ? "This product is hazmat"
        : "This product is not hazmat",
      tick: !data?.hazmat,
      isDanger: true,
      getValue: () => data?.hazmat,
    },
    {
      heading: "Variations",
      subheading: data?.variations
        ? "This product has some variations"
        : "This product does not have variations",
      tick: !data?.variations,
      isDanger: false,
      getValue: () => data?.variations,
    },
    {
      heading: "Private Label",
      subheading: data?.privateLabel
        ? "This Product has few historic sellers which is a sign it could be PL"
        : "This Product does not have few historic sellers",
      tick: !data?.privateLabel,
      isDanger: false,
      getValue: () => data?.privateLabel,
    },
    {
      heading: "Size",
      subheading: data?.size?.includes("oversize")
        ? "Not Standard"
        : "Large Standard",
      tick: !data?.size?.includes("oversize"),
      isDanger: false,
      getValue: () => data?.size?.includes("oversize"),
    },
  ];

  // Calculate alert counts
  const getAlertCounts = () => {
    let safe = 0;
    let warning = 0;
    let danger = 0;

    allAlerts.forEach((alert) => {
      if (alert.tick) {
        safe++;
      } else if (alert.isDanger) {
        danger++;
      } else {
        warning++;
      }
    });

    return { safe, warning, danger };
  };

  const alertCounts = getAlertCounts();

  return (
    <div
      className="flex flex-col w-full"
    >
      <div className="">
        <div
          className="flex cursor-pointer items-center mb-2 justify-between"
          onClick={toggleAccordion}
        >
          <div
            className="mr-1 text-primary font-bold"
            style={{
              fontSize: "16px",
            }}
          >
            Alerts
          </div>
          <div className="text-primary">
            {isOpen ? (
              <MdExpandMore className="w-6 h-6" />
            ) : (
              <MdExpandLess className="w-6 h-6" />
            )}
          </div>
        </div>
        {isOpen && (
          <div className="">
            <div className="flex justify-start items-center gap-2">
            {alertCounts.safe > 0 && (
              <div className="px-3 py-1 rounded-lg border border-primary bg-green-900/30">
                <span className="text-primary text-xs font-semibold">
                  {alertCounts.safe} in Safe
                </span>
              </div>
            )}
            {alertCounts.warning > 0 && (
              <div className="px-3 py-1 rounded-lg border border-[#EBAA07] bg-[#EBAA07]/20">
                <span className="text-[#EBAA07] text-xs font-semibold">
                  {alertCounts.warning} in Warning
                </span>
              </div>
            )}
            {alertCounts.danger > 0 && (
              <div className="px-3 py-1 rounded-lg border border-red-500 bg-red-900/30">
                <span className="text-red-500 text-xs font-semibold">
                  {alertCounts.danger} in Danger
                </span>
              </div>
            )}
          </div>
            {allAlerts.map((alert, index) => (
              <div
                key={index}
                className={`flex justify-between items-center bg-secondary-bg p-4 rounded-lg mt-2 gap-8`}
              >
                <div className="" style={{ textAlign: "left" }}>
                  <div className="text-white text-xs font-medium">{alert.heading}</div>
                    <h4
                      className={`text-sm font-semibold ${
                        alert.tick
                          ? "text-primary"
                          : alert.isDanger
                          ? "text-red-500"
                          : "text-[#EBAA07]"
                      }`}
                    >
                      {alert.subheading}
                    </h4>
                </div>
                <div>
                  {alert.tick ? (
                    <div className="bg-primary rounded-full p-1">
                      <FaCheck className="text-secondary" />
                    </div>
                  ) : (
                    alert.isDanger ? (
                      <div className="bg-secondary-bg rounded-full">
                        <MdDangerous className="text-red-500 w-7 h-7" />
                      </div>
                    ) : (
                      <div className="bg-secondary-bg rounded-full">
                        <IoAlertCircle className="text-[#EBAA07] w-7 h-7" />
                      </div>
                    )
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Alerts;
